export default [
    {
        path: "/publish/coy-transfer-part-one",
        component: () => import("./List.vue"),
        name: "publish-coy-transfer-part-one",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/publish/coy-transfer-part-one/:id/edit",
        component: () => import("./Edit.vue"),
        name: "publish-coy-transfer-one-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/publish/coy-transfer-part-one/create",
        component: () => import("./Create.vue"),
        name: "publish-coy-transfer-one-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/coy-transfer-part-one",
        component: () => import("./Events.vue"),
        name: "coy-transfer-one",
        meta: {
            requiresAuth: true,
        },
    },
];
